export const BuiltBySection = () => {
  return (
    <div className="bg-gray-100 dark:bg-black">
      <div className="container-xl relative py-48 md:pt-[84px] md:pb-[80px]">
        <div className="mb-32 space-x-24 text-center md:mx-[64px]">
          <span className="text-16-24 font-bold dark:text-gray-700">
            Built by researchers from
          </span>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-x-64 gap-y-20">
          <img src="/assets/logos/amazon.svg" alt="Amazon Research Cambridge" />
          <img src="/assets/logos/Google.svg" alt="Google Brain" />
          <img
            src="/assets/logos/Cambridge.svg"
            alt="University of Cambridge"
          />

          <img src="/assets/logos/Microsoft.svg" alt="Microsoft" />
          <img
            src="/assets/logos/ucl.svg"
            className="h-32 opacity-40 grayscale invert"
            alt="University College London"
          />
        </div>
      </div>
    </div>
  );
};
